export default function getRandomNumber(min, max) {
  return min + Math.random() * (max - min);
}
